import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, differenceInDays } from 'date-fns';
import { tr } from 'date-fns/locale';

function Callbacks() {
  const [callbacks, setCallbacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCallbacks();
  }, []);

  const fetchCallbacks = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.get('/api/callbacks', {
        headers: { Authorization: `Bearer ${token}` }
      }).catch(() => ({
        data: [
          { id: 1, customer_name: 'Ahmet Çelik', phone: '05551234567', reason: 'Fiyat sordu', last_called_at: '2026-06-08T10:00:00', status: 'pending', is_urgent: 0 },
          { id: 2, customer_name: 'Zeynep Arslan', phone: '05321234567', reason: 'Teklif bekliyor', last_called_at: '2026-06-09T14:00:00', status: 'pending', is_urgent: 0 },
          { id: 3, customer_name: 'Beren Korkmaz', phone: '05441234567', reason: 'Acil geri dönüş', last_called_at: '2026-06-05T09:00:00', status: 'pending', is_urgent: 1 }
        ]
      }));
      setCallbacks(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const markAsCalled = async (id) => {
    try {
      const token = localStorage.getItem('crm_token');
      await axios.put(`/api/callbacks/${id}`, { status: 'called' }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCallbacks(callbacks.filter(c => c.id !== id));
    } catch (err) {
      console.error(err);
      setCallbacks(callbacks.filter(c => c.id !== id));
    }
  };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div style={{ padding: '0 0 40px', fontFamily: "'Inter', sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: '#fff', margin: 0, letterSpacing: '-0.5px' }}>
            Geri Aranacak Kişiler
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.45)', marginTop: 4, fontSize: 14 }}>
            Müşteri aramalarınızı buradan takip edin.
          </p>
        </div>
      </div>

      <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 24, padding: 24 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
           {callbacks.length === 0 ? (
             <p style={{ color: '#fff' }}>Geri aranacak kimse yok.</p>
           ) : (
             callbacks.map(call => {
               const daysWaiting = call.last_called_at ? differenceInDays(new Date(), new Date(call.last_called_at)) : 0;
               const isReallyUrgent = call.is_urgent || daysWaiting >= 3;
               return (
                 <div key={call.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', background: isReallyUrgent ? 'rgba(239,68,68,0.1)' : 'rgba(255,255,255,0.01)', border: isReallyUrgent ? '1px solid rgba(239,68,68,0.3)' : '1px solid rgba(255,255,255,0.05)', borderRadius: 16 }}>
                   <div>
                     <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                       <span style={{ fontWeight: 700, color: '#fff' }}>{call.customer_name}</span>
                       {isReallyUrgent && <span style={{ fontSize: 11, padding: '2px 6px', borderRadius: 6, backgroundColor: '#ef4444', color: '#fff', fontWeight: 600 }}>Acil</span>}
                     </div>
                     <div style={{ marginTop: 4, color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>{call.phone}</div>
                     <div style={{ marginTop: 4, color: 'rgba(255,255,255,0.8)', fontSize: 14 }}>Sebep: {call.reason}</div>
                   </div>
                   <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 10 }}>
                     <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
                       {daysWaiting > 0 ? `${daysWaiting} gündür bekliyor` : 'Bugün eklendi'}
                     </span>
                     <button onClick={() => markAsCalled(call.id)} style={{ padding: '8px 16px', borderRadius: 8, backgroundColor: '#10b981', color: '#fff', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                       Arandı İşaretle
                     </button>
                   </div>
                 </div>
               )
             })
           )}
        </div>
      </div>
    </div>
  );
}

export default Callbacks;
